var ElementStyles = {
  MASK_LAYER: {
    'background-color': 'rgb(0, 0, 0)',
    'overflow': 'hidden',
    'position': 'fixed',
    'left': '0px',
    'top': '0px',
    'width': '100%',
    'height': '100%',
    'opacity': '0.4',
    'display': 'block'
  },
  CONTAINER: {
    'position': 'fixed',
    'left': 0,
    'top': 0,
    'width': '100%',
    'height': '100%',
    'z-index': '9008'
  },
  FRAME_CONTAINER: {
    'position': 'absolute',
    'z-index': '9999'
  },
  CLOSE_BUTTON: {
    'width': '14px',
    'height': '14px',
    'position': 'absolute',
    'right': '25px',
    'top': '14px',
    'cursor': 'pointer',
    'background-image': 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAAIVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzvu2GhAAAACnRSTlMAPkf4NvapcGh6jau6fQAAAEBJREFUCNdjIB4kAjFLAoglLMDA4KwAYjEaMrAEQaRFFVyBQmDB8CCYnq4JDAgxmDpRBYiQEUgvzDygZoQd+AEAWyAHHN07+zQAAAAASUVORK5CYII=)'
  },
  IFRAME: {
    'border-radius': '6px',
    'border-width': '1px'
  }
};
function convertElementStyles(target) {
  var resultStyle = '';
  for (var name in target) {
    if (target.hasOwnProperty(name)) {
      resultStyle += name + ':' + target[name] + ';';
    }
  }
  return resultStyle;
}
for (var name in ElementStyles) {
  if (ElementStyles.hasOwnProperty(name)) {
    ElementStyles[name] = convertElementStyles(ElementStyles[name]);
  }
}

function appendMaskLayer(container) {
  var maskLayer = document.createElement('div');
  maskLayer.style.cssText = ElementStyles.MASK_LAYER;
  container.appendChild(maskLayer);
}

function appendLoginFrame(container, layout, url) {
  var frameContainer = document.createElement('div');
  frameContainer.style.cssText = ElementStyles.FRAME_CONTAINER;
  frameContainer.style.left = (window.innerWidth - layout.width) / 2 + 'px';
  frameContainer.style.top = (window.innerHeight - layout.height) / 2 + 'px';
  window.addEventListener('resize', function() {
    frameContainer.style.left = (window.innerWidth - layout.width) / 2 + 'px';
    frameContainer.style.top = (window.innerHeight - layout.height) / 2 + 'px';
  });
  var iframeTag = document.createElement('iframe');
  iframeTag.setAttribute('frameborder', '0');
  iframeTag.src = url;
  iframeTag.width = layout.width;
  iframeTag.height = layout.height;
  iframeTag.scrolling = 'no';
  iframeTag.style.cssText = ElementStyles.IFRAME;
  frameContainer.appendChild(iframeTag);
  appendCloseButton(container, frameContainer, iframeTag);
  container.appendChild(frameContainer);
}

function appendCloseButton(container, frameContainer, iframeTag) {
  var closeButton = document.createElement('div');
  closeButton.style.cssText = ElementStyles.CLOSE_BUTTON;
  closeButton.onclick = function() {
    container.style.display = 'none';
    iframeTag.src = '';
  };
  frameContainer.appendChild(closeButton);
}

function generateRequestUrl(state) {
  // http://wiki.connect.qq.com/%E4%BD%BF%E7%94%A8authorization_code%E8%8E%B7%E5%8F%96access_token
  return location.protocol + '//open.youtu.qq.com/v2/ytuser_ctl/prelogin';
}

var qc = {
  containerId: 'youtu-qc-login-container',
  state: null,
  layout: {
    width: 500,
    height: 400
  },
  showLogin: function(callback) {
    var url = generateRequestUrl(this.state);
    var container = document.getElementById(this.containerId);
    if (container) {
      container.style.display = '';
      var existFrame = container.getElementsByTagName('iframe')[0];
      existFrame.src = url;
      return;
    }
    container = document.createElement('div');
    document.body.appendChild(container);
    container.id = this.containerId;
    container.style.cssText = ElementStyles.CONTAINER;
    appendMaskLayer(container);
    appendLoginFrame(container, this.layout, url);

    function onReceiveMessage(data) {
      container.style.display = 'none';
      var existFrame = container.getElementsByTagName('iframe')[0];
      existFrame.src = '';
      if (callback) {
        callback(data);
      }
    };

    // set callback
    window.youtuQc = {
      callback: function(data) {
        onReceiveMessage(data);
      }
    };
    window.addEventListener('message', function(e) {
      console.log(e);
      if (e.type !== 'message') {
        return;
      }
      if (e.data && e.data.errorcode == null) {
        return;
      }
      onReceiveMessage(e.data);
    });
  }
};
module.exports = qc;



// WEBPACK FOOTER //
// ./src/components/open/common/plugin/qc.js